module.exports = __webpack_public_path__ + "static/media/avatar-2.e81add46.jpg";